import http from './httpService';
import config from '../configs/config.js';
import Data from '../configs/config.js';

const url = config.apiEndPoint + '/users';
const admin_url = config.apiEndPoint + '/admin/users';

function generateURL(path, type = '') {
  return `${type === 'admin' ? admin_url : url}/${path}`;
}

// ------------------------------------ NORMAL USER SERVICES -------------------------------------------- //

export async function getMyData() {
  let user = await http.get(generateURL('me'));
  return user;
}

export async function editMe(user) {
  const body = user;
  let users = await http.put(generateURL('me'), body);
  return users;
}

// ------------------------------------ ADMIN USER SERVICES -------------------------------------------- //

// 1. Get user information
export async function getUsers() {
  let users = await http.get(admin_url);
  return users;
}

export async function getUserbyID(id) {
  let user = await http.get(generateURL(id, 'admin'));
  return user;
}

// 2. Create new user
export async function createUser(user) {
  const body = {
    email: user.username + '@' + Data.domain,
    is_active: user.is_active,
    is_superuser: user.is_superuser,
    first_name: user.first_name,
    last_name: user.last_name,
    password: user.password,
    persona_uuid: user.persona_uuid
  };
  let users = await http.post(admin_url, body);
  return users;
}

// 3. Edit user permissions
export async function editUser(user, id) {
  Object.keys(user).forEach((key) => {
    if (user[key] == null || user[key].length === 0) {
      delete user[key];
    }
  });
  const body = user;
  let users = await http.put(generateURL(id, 'admin'), body);
  return users;
}

// 4. Delete user
export async function deleteUser(user) {
  let users = await http.delete(generateURL(user.user_uuid, 'admin'));
  return users;
}
